<template>
  <b-row>
    <b-col md="12">
      <b-card>
        <div slot="header">
          <strong>보고서</strong> 정보 (<span style="color:#ea0000">{{'구매된 보고서 수 : '+Number(productDataItems.in_purchase_cnt).toLocaleString()}}</span>)
        </div>
        <div class="table-responsive-sm">
          <table class="table b-table table-striped">
              <thead class="" style="background-color:#f1f1f1">
                  <tr style="text-align:center">
                      <th class="" style="border-right:1px solid #a4b7c1; vertical-align:middle">보고서코드</th>
                      <th class="" style="border-right:1px solid #a4b7c1; vertical-align:middle">보고서명</th>
                      <th class="" style="border-right:1px solid #a4b7c1; vertical-align:middle">판매구분</th>
                      <th class="" style="border-right:1px solid #a4b7c1; vertical-align:middle">등록일</th>
                      <th class="" style="border-right:1px solid #a4b7c1; vertical-align:middle">노출</th>
                      <th class="" style="vertical-align:middle">조회수</th>
                  </tr>
              </thead>
              <tbody class="">
                  <!---->
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0; text-align:center">
                      <td class="" style="border-right:1px solid #a4b7c1">{{productDataItems.p_code}}</td>
                      <td class="" style="border-right:1px solid #a4b7c1">{{productDataItems.p_name}}</td>
                      <td class="" style="border-right:1px solid #a4b7c1">유료</td>
                      <td class="" style="border-right:1px solid #a4b7c1">{{productDataItems.reg_date}}</td>
                      <td class="" style="border-right:1px solid #a4b7c1">{{productDataItems.view_name}}</td>
                      <td class="">{{productDataItems.view_cnt}}</td>
                  </tr>
              </tbody>
          </table>
        </div>
      </b-card>
    </b-col>
    <b-col md="12">
      <b-card>
        <div slot="header">
          기본 정보
        </div>
        <div class="table-responsive-sm">
          <table id="__BVID__2714" aria-busy="false" aria-colcount="4" aria-rowcount="-1" class="table b-table table-striped">
              <tbody class="">
                <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                    <td width="150" style="background-color:#f1f1f1">
                      <label class="col-form-label">보고서 분류</label>
                    </td>
                    <td class="" colspan="3">
                      <label class="col-form-label">{{productDataItems.p_typename}}</label>
                    </td>
                    <td width="150" style="background-color:#f1f1f1">
                      <label class="col-form-label">등록일</label>
                    </td>
                    <td class="">
                      <label class="col-form-label">{{productDataItems.reg_date}}</label>
                    </td>
                </tr>
                <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                    <td width="150" style="background-color:#f1f1f1">
                      <label class="col-form-label">보고서명</label>
                    </td>
                    <td class="" colspan="5">
                      <label class="col-form-label">{{productDataItems.p_name}}</label>
                    </td>
                </tr>
                <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                  <td width="150" style="background-color:#f1f1f1">
                    <label class="col-form-label">노출여부</label>
                  </td>
                  <td class="" colspan="3">
                    <label class="col-form-label">
                      <b-form-radio-group
                        id="basicCustomViewyn"
                        name="viewyn">
                        <div class="custom-control custom-radio custom-control-inline">
                          <input type="radio" id="viewY" name="viewyn" disabled class="custom-control-input" v-model="productDataItems.view_yn" value="Y">
                          <label class="custom-control-label" for="viewY">노출</label>
                        </div>
                        <div class="custom-control custom-radio custom-control-inline">
                          <input type="radio" id="viewN" name="viewyn" disabled class="custom-control-input" v-model="productDataItems.view_yn" value="N">
                          <label class="custom-control-label" for="viewN">비노출</label>
                        </div>
                      </b-form-radio-group>
                    </label>
                  </td>
<!--                  <td width="150" style="background-color:#f1f1f1">-->
<!--                    <label class="col-form-label">리스트 노출관리</label>-->
<!--                  </td>-->
<!--                  <td class="">-->
<!--                    <label class="col-form-label">-->
<!--                      <b-form-checkbox-group id="basicInlineCustomCheckboxes">-->
<!--                        <div class="custom-control custom-checkbox custom-control-inline">-->
<!--                          <input type="checkbox" class="custom-control-input" disabled id="customInChk1" v-model="productDataItems.bestview_yn">-->
<!--                          <label class="custom-control-label" for="customInChk1">인기 리포트 등록</label>-->
<!--                        </div>-->
<!--                      </b-form-checkbox-group>-->
<!--                    </label>-->
<!--                  </td>-->
                </tr>
              </tbody>
          </table>
        </div>
      </b-card>
    </b-col>
    <b-col md="12">
      <b-card>
        <div slot="header">
          <strong>상세 정보</strong>
          <span class="badge badge-danger">유료</span>
        </div>
        <div style="margin-bottom:20px">
          <b-nav justified tabs>
            <b-nav-item v-bind:active="optiontap == 'normaltap'" v-on:click="reporttapOption('normaltap')">상세정보</b-nav-item>
            <b-nav-item v-bind:active="optiontap == 'optiontap'" v-on:click="reporttapOption('optiontap')">옵&nbsp;&nbsp;&nbsp;션</b-nav-item>
            <b-nav-item disabled></b-nav-item>
            <b-nav-item disabled></b-nav-item>
          </b-nav>
        </div>
        <div class="table-responsive-sm" v-show="optiontap == 'normaltap'">
          <table id="__BVID__2714" aria-busy="false" aria-colcount="4" aria-rowcount="-1" class="table b-table table-striped">
              <tbody class="">
                <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                    <td width="150" style="background-color:#f1f1f1">
                      <label class="col-form-label">페이지</label>
                    </td>
                    <td class="" colspan="4">
                      <label class="col-form-label">{{productDataItems.page_cnt}}</label>
                    </td>
                </tr>
                <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                    <td width="150" style="background-color:#f1f1f1">
                      <label class="col-form-label">표본수</label>
                    </td>
                    <td class="">
                      <label class="col-form-label">{{productDataItems.sample_comment}}</label>
                    </td>
                    <td width="150" style="background-color:#f1f1f1">
                      <label class="col-form-label">IBSN</label>
                    </td>
                    <td class="">
                      <label class="col-form-label">{{productDataItems.ibsn}}</label>
                    </td>
                </tr>
                <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                    <td width="150" style="background-color:#f1f1f1">
                      <label class="col-form-label">카테고리</label>
                    </td>
                    <td class="" colspan="4">
                      <b-row class="pt-sm-12">
                        <b-col sm="12">
                          <span v-for="(categoryItem, idx) in productDataItems.categoryitems" class="bg-primary p-2 mr-2 float-left" style="border-radius:5px">{{categoryItem.cate_name}}</span>
                        </b-col>
                      </b-row>
                    </td>
                </tr>
                <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                    <td width="150" style="background-color:#f1f1f1">
                      <label class="col-form-label">미리보기(JPG,PNG)</label>
                    </td>
                    <td class="" colspan="4">
                      <div v-show="productDataItems.previewFileItems.length == 0">
                        <label class="col-form-label">등록된 파일이 없습니다.</label>
                      </div>
                      <b-col md="6" style="margin-left:-13px">
                        <li class="list-group-item" v-for="(previewFile, idx) in productDataItems.previewFileItems"
                          style="padding: 0px 0px 10px 10px;">
                          <label class="col-form-label">
                            <i class="fa fa-file-image-o fa-2x mt-1 bg-info"></i>
                            {{previewFile.file_originalname}} ({{previewFile.filesizeStr}})
                            <p class="fileurl" style="display: none;">{{previewFile.file_url}}</p>
                          </label>
                        </li>
                      </b-col>
                    </td>
                </tr>
                <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                    <td width="150" style="background-color:#f1f1f1">
                      <label class="col-form-label">
                        목록 썸네일 이미지
                        <br/>
                        (730 x 410)
                      </label>
                    </td>
                    <td class="" colspan="4">
                      <div v-show="productDataItems.listThumbnailFile.length == 0">
                        <label class="col-form-label">등록된 파일이 없습니다.</label>
                      </div>
                      <div v-for="(listThumbnail, idx) in productDataItems.listThumbnailFile">
                        <label class="imgview col-form-label" :data="listThumbnail.file_url"><i class="fa fa-file-image-o fa-2x mt-1 bg-info"></i> {{listThumbnail.file_originalname}} ({{listThumbnail.filesizeStr}})</label>
                      </div>
                    </td>
                </tr>
                <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                    <td width="150" style="background-color:#f1f1f1">
                      <label class="col-form-label">TAG</label>
                    </td>
                    <td class="" colspan="4">
                      <label class="col-form-label">{{productDataItems.tag}}</label>
                    </td>
                </tr>
                <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                    <td width="150" style="background-color:#f1f1f1">
                      <label class="col-form-label">개요</label>
                    </td>
                    <td class="" colspan="4">
                      <label class="col-form-label"><div v-html="productDataItems.summary"></div></label>
                    </td>
                </tr>
                <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                    <td width="150" style="background-color:#f1f1f1">
                      <label class="col-form-label">목차</label>
                    </td>
                    <td class="" colspan="4">
                      <label class="col-form-label"><div v-html="productDataItems.toc"></div></label>
                    </td>
                </tr>
                <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                    <td width="150" style="background-color:#f1f1f1">
                      <label class="col-form-label">상세 설명</label>
                    </td>
                    <td class="" colspan="4">
                      <label class="col-form-label"><div v-html="productDataItems.detaile_content"></div></label>
                    </td>
                </tr>
              </tbody>
          </table>
        </div>

        <div class="table-responsive-sm" v-show="optiontap == 'optiontap'">
          <table class="table b-table table-striped">
              <thead class="" style="background-color:#f1f1f1">
                  <tr style="text-align:center">
                      <th class="">패키지</th>
                  </tr>
              </thead>
              <tbody class="">
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0; text-align:center">
                      <td class="">
                        <a href="javascript:void(0)">
                          <label class="col-form-label">
                            <label class="switch switch-3d switch-primary">
                              {{pkgList.length}}종
                            </label>
                          </label>
                        </a>
                      </td>
                  </tr>
              </tbody>
          </table>

          <div class="table-responsive-sm">
            <table class="table b-table table-striped">
                <thead class="" style="background-color:#f1f1f1">
                    <tr style="text-align:center">
                        <th class="" style="border-right:1px solid #a4b7c1">번호</th>
                        <th class="" style="border-right:1px solid #a4b7c1">옵션분류</th>
                        <th class="" style="border-right:1px solid #a4b7c1">패키지코드</th>
                        <th class="" style="border-right:1px solid #a4b7c1">옵션명</th>
                        <th class="" style="border-right:1px solid #a4b7c1">소비자가</th>
                        <th class="" style="border-right:1px solid #a4b7c1">노출여부</th>
                        <th class="" style="border-right:1px solid #a4b7c1">옵션수량</th>
                        <th class="" style="border-right:1px solid #a4b7c1">등록일</th>
                        <th class="" style="border-right:1px solid #a4b7c1">등록자</th>
                    </tr>
                </thead>
                <tbody class="">
                    <!---->
                    <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0; text-align:center" v-show="pkgList.length > 0" v-for="(item, idx) in pkgList">
                        <td class="" style="border-right:1px solid #a4b7c1">{{idx+1}}</td>
                        <td class="" style="border-right:1px solid #a4b7c1">패키지</td>
                        <td class="" style="border-right:1px solid #a4b7c1">{{item.pkg_code}}</td>
                        <td class="" style="border-right:1px solid #a4b7c1">{{item.name}}</td>
                        <td class="" style="border-right:1px solid #a4b7c1; text-align:left">
                          <span style="padding-left:20px">보안PDF : ₩ {{item.security_price}}</span></br>
                          <span style="padding-left:20px">일반PDF : ₩ {{item.normal_price}}</span></br>
                        </td>
                        <td class="" style="border-right:1px solid #a4b7c1"><span v-text="item.exposure == 0 ? '비노출' : '노출'"></span>({{item.exposure}})</td>
                        <td class="" style="border-right:1px solid #a4b7c1">{{item.opt_cnt}}</td>
                        <td class="" style="border-right:1px solid #a4b7c1">{{item.reg_date}}</td>
                        <td class="" style="border-right:1px solid #a4b7c1">{{item.reg_name}}</td>
                    </tr>
                    <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0; text-align:center" v-show="pkgList.length == 0">
                        <td class="" colspan="9">데이터가 없습니다.</td>
                    </tr>
                </tbody>
            </table>
          </div>
        </div>
      </b-card>

      <b-card style="padding:0px" v-show="optiontap == 'optiontap'">
        <div slot="header">패키지 포함 리포트 목록</div>
        <table class="table b-table table-striped">
          <thead class="" style="background-color:#f1f1f1">
          <tr style="text-align:center">
            <th class="" style="border-right:1px solid #a4b7c1">보고서코드</th>
            <th class="" style="border-right:1px solid #a4b7c1">옵션코드</th>
            <th class="" style="border-right:1px solid #a4b7c1">리포트명</th>
            <th class="" style="border-right:1px solid #a4b7c1">대메뉴</th>
            <th class="" style="border-right:1px solid #a4b7c1">등록일</th>
          </tr>
          </thead>
          <tbody class="">
          <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0; text-align:center" v-show="productPkgOptions.optItems.length > 0" v-for="(item, idx) in productPkgOptions.optItems">
            <td class="" style="border-right:1px solid #a4b7c1">{{item.dr_code}}</td>
            <td class="" style="border-right:1px solid #a4b7c1">{{item.opt_code}}</td>
            <td class="" style="border-right:1px solid #a4b7c1">{{item.report_name}}</td>
            <td class="" style="border-right:1px solid #a4b7c1">{{item.name}}</td>
            <td class="" style="border-right:1px solid #a4b7c1">{{item.reg_date}}</td>
          </tr>
          <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0; text-align:center" v-show="productPkgOptions.optItems.length < 1">
            <td class="" colspan="9">데이터가 없습니다.</td>
          </tr>
          </tbody>
        </table>
      </b-card>

      <b-row style="margin-bottom:1.5em">
        <b-col sm="3" lg="4">
          &nbsp;
        </b-col>
        <b-col sm="3" lg="4">
          &nbsp;
        </b-col>
        <b-col sm="3" lg="4">
          <div style="float:right; width:70%">
            <b-row>
              <b-col md="4">
                <b-button variant="danger" style="color:#ffffff; border-radius:5px; cursor:pointer; width:100%; border:1px solid #f42f2d; font-size:15px" v-on:click="drProductDelete(p_param_code)"><h5 style="margin-bottom:0px"><i class="fa fa-remove"></i> 삭제</h5></b-button>
              </b-col>
              <b-col md="4">
                <b-button variant="warning" style="color:#ffffff; border-radius:5px; cursor:pointer; width:100%; border:1px solid #c5940d; font-size:15px" v-bind:href="'#/product/annualreport/form?status=update'"><h5 style="margin-bottom:0px"><i class="fa fa-edit"></i> 수정</h5></b-button>
              </b-col>
              <b-col md="4">
                <b-button variant="primary" style="color:#ffffff; border-radius:5px; cursor:pointer; width:100%; border:1px solid #187c9f; font-size:15px" v-bind:href="'#/product/annualreport'"><i class="fa fa-list-ul"></i> 목록</h5></b-button>
              </b-col>
            </b-row>
          </div>
        </b-col>

        <!-- b-col sm="6" lg="3">
          <b-card no-body class="bg-warning">
            <b-card-body class="pb-0">
              <b-dropdown class="float-right" variant="transparent p-0" right>
                <template slot="button-content">
                  <i class="icon-settings"></i>
                </template>
                <b-dropdown-item>Action</b-dropdown-item>
                <b-dropdown-item>Another action</b-dropdown-item>
                <b-dropdown-item>Something else here...</b-dropdown-item>
                <b-dropdown-item disabled>Disabled action</b-dropdown-item>
              </b-dropdown>
              <h4 class="mb-0">9.823</h4>
              <p>Members online</p>
            </b-card-body>
            <card-line3-chart-example class="chart-wrapper" style="height:70px;" height="70"/>
          </b-card>
        </b-col -->
      </b-row>
    </b-col>
  </b-row>
</template>
<script>
import cSwitch from '../../components/Switch';
import swal from 'sweetalert2'

export default {
  components: {
    cSwitch,
  },
  data() {
    return {
      opttapCheck: true,
      pkgtapCheck: false,
      p_param_code: '',
      productDeleteRows: [],
      productDataItems: {
        attachmentFileItems:[],
        previewFileItems:[],
        listThumbnailFile:[],
        categoryitems:[],
      },
      optList: [],
      pkgList: [],
      optiontap:'normaltap',
      tap_option_type:'POT_1',
      productPkgOptions :{
        optItems : [],
      },
      queryParams :{
        p_code : '',
        p_pkg_code : '',
      },
    }
  },
  watch: {},
  mounted: function() {
    var token = sessionStorage.getItem("myToken");
    var self = this;
    self.p_param_code = self.$session.get('p_param_code');
    // ### 상품 정보 불러오기 ###
    // 상품정보를 DB테이블에서 조회
    // 최초작성 : 2016.06.27
    // 파라미터 : p_param_code
    //  - p_param_code
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2019.06.27  황경현   최초작성
    // *************************
    if(self.p_param_code != undefined){
      self.$http.get('/api/select/drProductData?access_token=' + token + '&p_param_code=' + self.p_param_code)
      .then((result) => {
        self.productDataItems = result.data;
        self.productDataItems.bestview_yn = self.productDataItems.bestview_yn == "Y" ? true : false;
        console.log(self.productDataItems);
        if(self.productDataItems.listThumbnail == null){
          self.productDataItems.listThumbnail = {
              file_originalname: '파일없음',
              filesizeStr: '0',
          }
        }
      })

      // ### 리포트 패키지 옵션 정보 불러오기 ###
      // 리포트정보 옵션을 DB테이블에서 조회
      // 최초작성 : 2016.06.27
      // 파라미터 : p_param_code
      //  - p_param_code
      // *************************
      // ## 코드 히스토리 ##
      //    날짜    작성자     수정내용
      // 2019.06.27  황경현   최초작성
      // *************************
      self.$http.get('/api/select/drProductOptList?access_token=' + token + '&p_param_code=' + self.p_param_code + '&p_sub_type=')
      .then((result) => {
        self.optList = result.data.optList;
        self.pkgList = result.data.pkgList;
        if(self.pkgList.length > 0){
          self.pkgList.forEach(function (el, idx, arr){
            if(el.security_price != 0){
              el.security_price = Number(el.security_price).toLocaleString();
            }
            if(el.normal_price != 0){
              el.normal_price = Number(el.normal_price).toLocaleString();
            }
          });
          this.getReportOptList(result.data.pkgList[0].p_code, result.data.pkgList[0].pkg_code )
        }
      })
    }
  },
  methods: {
    reporttapOption (optiontype) {
      this.optiontap = optiontype;
    },
    optPkgCheck(event,check){
      if(!check){
        this.opttapCheck = !this.opttapCheck;
        this.pkgtapCheck = !this.pkgtapCheck;
      }else{
        event.target.checked = true;
      }
    },
    drProductDelete(prCodeDel){
      var self = this;
      self.productDeleteRows = [];

      if(self.productDataItems.in_purchase_cnt > 0){
        swal.fire({
          type: 'warning',
          title: '보고서 삭제!',
          html: "<b>구매된 보고서는 삭제할수 없습니다.</br><span style='color:#ea0000'>구매건 수 : "+self.productDataItems.in_purchase_cnt+"건</span></b>",
          showConfirmButton: true
        })
        return false;
      }

      swal.fire({
        title: '보고서 삭제!',
        // text: "기본정보 이외에 작성한 데이터는 모두 초기화 됩니다. "+messageValue+"로 변경하시겠습니까?",
        html: "해당 보고서 상품의 각종 패키지 저장된 데이터</br> 모두 삭제 됩니다. 삭제하시겠습니까?",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'OK'
      }).then((swalResult) => {
        if (swalResult.value) {
          // ok
          self.productDeleteRows.push(prCodeDel);
          var token = sessionStorage.getItem("myToken");
          var param = encodeURI(JSON.stringify(self.productDeleteRows));
          var data = new FormData();
          data.append('productDelArr', param);

          self.$http.post('/api/delete/drProduct?access_token='+token, data, null)
            .then((result) => {
              swal.fire({
                type: 'success',
                title: '보고서 상품이 삭제되었습니다.',
                showConfirmButton: false,
                timer: 1000
              }).then(function() {
                  window.location = "#/product/annualreport";
              });
          })
        }else{
          // cancel
        }
      })
    },
    getReportOptList(pCode, pkgCode){
      const token = sessionStorage.getItem("myToken");

      this.queryParams.p_code = pCode
      this.queryParams.p_pkg_code = pkgCode

      const param = encodeURI(JSON.stringify(this.queryParams));
      let data = new FormData();
      data.append('pkgInfoObj', param);

      this.$http.post('/api/select/getProductPkgOptList?access_token='+token, data, null)
        .then((result) => {
            this.productPkgOptions.optItems = result.data
      }).catch((error) =>{
            console.error(error)
      })
    },

  }
}

$(document).ready(function(){
	var xOffset = 50;
  var yOffset = 10;
  $(document).on("mouseover",".imgview",function(e){ //마우스 오버시
      $("body").append("<p id='preview'><img src='"+ $(this).attr("data") +"' /></p>"); //보여줄 이미지를 선언
      $("#preview")
          .css("position","absolute")
          .css("top",(e.pageY - xOffset) + "px")
          .css("left",(e.pageX + yOffset) + "px")
          .fadeIn("fast"); //미리보기 화면 설정 셋팅
  });
  $(document).on("mousemove",".imgview",function(e){ //마우스 이동시
      $("#preview")
          .css("top",(e.pageY - xOffset) + "px")
          .css("left",(e.pageX + yOffset) + "px");
  });
  $(document).on("mouseout",".imgview",function(){ //마우스 아웃시
      $("#preview").remove();
  });
});
</script>



// WEBPACK FOOTER //
// src/views/product/AnnualReportInfo.vue